import { render, staticRenderFns } from "./SpanFields.vue?vue&type=template&id=47ffd9dd"
import script from "./SpanFields.vue?vue&type=script&lang=js"
export * from "./SpanFields.vue?vue&type=script&lang=js"
import style0 from "./SpanFields.vue?vue&type=style&index=0&id=47ffd9dd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports